import { render } from "./UpdateLocation.vue?vue&type=template&id=4452c142"
import script from "../js/update-location.js?vue&type=script&lang=js"
export * from "../js/update-location.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__